.floatingButton {
    position: fixed;
    bottom: 20px;
    left: 20px;
    z-index: 1000;
    cursor: pointer;

    border: none;
    padding: 0;
    margin: 0;
    outline: none;
    box-shadow: none;

    font-size: 40px;
    padding-left: 5px;
    padding-right: 5px;
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 #000000a6;
    height: 60px;
    min-width: 60px;

    display: flex;
    justify-content: center;
    align-items: center;

    transition: opacity ease 0.3s;

    &:hover {
        background: #f5f5f5;
    }

    &.isOpened {
        opacity: 0;
        pointer-events: none;
    }
}

@keyframes appear {
    from {
        opacity: 0;
        transform: translateY(150%);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes disappear {
    from {
        opacity: 1;
        transform: translateY(0);
    }

    to {
        opacity: 0;
        transform: translateY(150%);
    }
}

.panelContainer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10000;
    background: white;
    box-shadow: 0 2px 4px 0 #000000a6;
    animation: appear 0.3s ease;
    max-height: 80vh;
    overflow-y: auto;
    overflow-x: hidden;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    gap: 12px;
    padding: 12px;

    &.isClosing {
        animation: disappear 0.3s ease;
    }

    .divider {
        width: 100%;
        height: 1px;
        background: #0000007e;
        margin: 6px 0;
    }

    .groupContainer {
        display: flex;
        flex-direction: column;
        width: 100%;
        border-bottom: 1px solid #0000001a;
        padding-bottom: 12px;
        margin-bottom: 4px;

        &.last {
            border-bottom: none;
            margin-bottom: 0;
            padding-bottom: 0;
        }
    }

    .groupTitle {
        font-size: 16px;
        font-weight: 600;
        margin: 0 0 8px 0;
        padding: 0;
        color: #333;
    }

    .elementsRow {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 12px;
        align-items: center;
    }

    .panelButton {
        border: none;
        padding: 0;
        margin: 0;
        outline: none;
        box-shadow: none;
        background: white;
        border-radius: 4px;
        font-size: 30px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
        min-height: 40px;
        min-width: 40px;
        padding-left: 5px;
        padding-right: 5px;
        cursor: pointer;

        display: flex;
        justify-content: center;
        align-items: center;

        transition: opacity ease 0.3s;

        &:hover {
            background: #f5f5f5;
        }

        position: relative;
        .shortcut {
            position: absolute;
            left: 3px;
            bottom: 2px;
            font-size: 10px;
            color: #666;
        }
    }
}

.icon {
    height: 1em;
    margin: 0;
}